import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";

// ========================== | MODAL DE RECHAZO | ======================================

export const RejectOrderModal = ({ open, onClose, onConfirm, orderNumber }) => {
  const [rejectionReason, setRejectionReason] = useState("");
  const [error, setError] = useState(false);

  const handleConfirm = () => {
    if (!rejectionReason.trim()) {
      setError(true);
      return;
    }
    onConfirm(rejectionReason);
    setRejectionReason("");
    setError(false);
  };

  const handleClose = () => {
    setRejectionReason("");
    setError(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CancelIcon color="error" />
          <Typography variant="h6">
            Rechazar Pedido
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          ¿Está seguro que desea rechazar el pedido #{orderNumber}?
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Motivo del Rechazo"
          placeholder="Ingrese el motivo del rechazo..."
          value={rejectionReason}
          onChange={(e) => {
            setRejectionReason(e.target.value);
            setError(false);
          }}
          error={error}
          helperText={
            error
              ? "El motivo del rechazo es obligatorio"
              : ""
          }
          required
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Confirmar Rechazo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

